module.exports = __webpack_public_path__ + "static/media/multiple-choice.e99eda58.jpg";